<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/111qiug/tc-custom/9781449412746.jpg?1701092371630" alt="This image is the cover for the book All Wound Up"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All Wound Up
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling author of <i>Yarn Harlot</i> returns with more witty stories about knitting, motherhood, friendship, and more.</b><br/><br/>In this all-new collection of yarns, <i>New York Times</i>–bestselling author and self-proclaimed yarn Harlot Stephanie Pearl-McPhee is all wound up about life, motherhood, losing her beloved washing machine, and, of course, knitting.<br/><br/>With trademark humor and wit that have sustained her through thick and thin, including a few misshapen sweaters and an indoor water balloon fight among her otherwise darling daughters, Pearl-McPhee deftly examines knitting, parenting, friendship, and—gasp!—even crocheting in essays that are at times touching, often hilarious, and always entertaining.<br/><br/><b>Praise for <i>Yarn Harlot</i></b><br/><br/><b>“A sort of David Sedaris-like take on knitting—laugh-out-loud funny most of the time and poignantly reflective when it’s not cracking you up.” —<i>Library Journal</i></b><br/><br/><b>“Pearl-McPhee turns both typical and unique knitting experiences into very funny and articulate prose.” —Meg Swansen, Schoolhouse Press</b><br/><br/><b>“I laughed until my stitches fell helplessly from my needles!” —Lucy Neatby, author of <i>Cool Socks Warm Feet</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Pearl-McPhee
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4309386b